import { useState } from "react";
import styled from "styled-components/macro";
import SettingsIcon from "@mui/icons-material/Settings";
import { IconButton } from "@mui/material";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { ClickAwayListenerNS } from "pages/DashboardPages/ProcessTilesControls/ClickAwayListenerNS";
import { TooltipNS } from "pages/DashboardPages/ProcessTilesControls/TooltipNS";
import TimelinesConfig from "./TimelinesConfig";

const TimelineCardControls = () => {
  const [open, setIsConfigOpen] = useState(false);
  return (
    <ClickAwayListenerNS onClickAway={() => setIsConfigOpen(false)}>
      <ControlsStyles className="doNotPrint">
        <BtnShowConfig {...{ setIsConfigOpen }} />
        {open ? <TimelinesConfig /> : null}
      </ControlsStyles>
    </ClickAwayListenerNS>
  );
};

export default TimelineCardControls;

function BtnShowConfig({
  setIsConfigOpen,
}: {
  setIsConfigOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { translate } = useFlightTranslation();

  return (
    <TooltipNS
      title={translate("Configure_Timeline")}
      placement="bottom-start"
      PopperProps={{ className: "btnOpenConfigTooltip" }}
      disableInteractive={true}
    >
      <IconButton
        className="btnOpenConfig"
        size="small"
        onClick={e => {
          e.stopPropagation();
          setIsConfigOpen(p => !p);
        }}
      >
        <SettingsIcon />
      </IconButton>
    </TooltipNS>
  );
}

const ControlsStyles = styled.div``;
